// Generated by ts-to-zod
import { z } from 'zod';

export const patchWorkspacePayloadSchema = z.object({
  name: z.string(),
});
